//  Importing Dependancies
import React from "react"
import { Link } from "react-router-dom"
import ScrollableAnchor from "react-scrollable-anchor"
import { configureAnchors } from "react-scrollable-anchor"

//  Importing Components
import Divider from "../Divider/Divider"
import Button from "../Button/Button"
import FullMenuItem from "../FullMenuItem/FullMenuItem"
import Cta from "../Cta/Cta"

//  Importing Images
import hibachiMenu from "../images/menu.svg"
import salad from "../images/salad.svg"
import soup from "../images/soup.svg"
import rice from "../images/rice.svg"
import scallops from "../images/seashell.svg"
import vegetables from "../images/vegetables.svg"
import steak from "../images/steak.svg"
import shrimp from "../images/shrimp.svg"
import chicken from "../images/chicken.svg"
import filetMignon from "../images/filet-mignon.svg"
import tuna from "../images/big-tuna.svg"
import mahi from "../images/mahi.svg"
import salmon from "../images/big-salmon.svg"
import lobster from "../images/lobster.svg"

//  Importing CSS
import "./FullMenu.css"

const FullMenu = props => {
  return (
    <div className="full-menu">
      <div className="full-menu__header-container">
        <div className="full-menu__bg" />
        <div className="full-menu__header">
          <img alt="Menu" className="full-menu__icon" src={hibachiMenu} />
          <h1>Full Menu</h1>
          <div className="full-menu__buttons-wrapper">
            <a href="#StarterMenu">
              <button className="button">Starter Menu</button>
            </a>
            <a href="#SpecialsMenu">
              <button className="button">Specials Menu</button>
            </a>
          </div>
        </div>
      </div>

      <ScrollableAnchor id="StarterMenu">
        <div className="full-menu__standard-header">
          <div className="full-menu__submenu-header">
            <h1>Starter Menu</h1>
          </div>
          <Divider />
          <p>
            This is our starter menu that is included at every Hibachi & You
            party. <span>This menu includes the following:</span>
          </p>
        </div>
      </ScrollableAnchor>
      <div className="full-menu__standard">
        <FullMenuItem
          foodName="Shrimp"
          foodId="Shrimp"
          description="Succulent shrimp. Seasoned with salt, 
            lemon, pepper, garlic butter and soy sauce."
          background="full-menu__shrimp"
          foodIcon={shrimp}
        />
        <FullMenuItem
          foodName="Steak"
          foodId="Steak"
          description="Mouth watering steak, cooked medium. Seasoned with salt, 
            lemon, pepper, garlic butter and soy sauce."
          background="full-menu__steak"
          foodIcon={steak}
        />
        <FullMenuItem
          foodName="Chicken"
          foodId="Chicken"
          description="Juicy chicken breast cooked hibachi style. Seasoned with salt, 
            lemon, pepper, garlic butter and soy sauce."
          background="full-menu__chicken"
          foodIcon={chicken}
        />
        <FullMenuItem
          foodName="Fried Rice"
          foodId="FriedRice"
          description="Classic Hibachi style fried rice. Cooked and mixed with eggs. Seasoned with salt, 
            pepper, soy sauce and garlic butter"
          background="full-menu__fried-rice"
          foodIcon={rice}
        />
        <FullMenuItem
          foodName="Fried Vegetables"
          foodId="FriedVegetables"
          description="Hibachi style cooked vegetables: 
            zuccini, onions, mushrooms, broccoli and carrots."
          background="full-menu__vegetables"
          foodIcon={vegetables}
        />
      </div>

            <div className="full-menu__specials">
        <ScrollableAnchor id="Sides">
          <div className="full-menu__standard-header">
            <div className="full-menu__submenu-header">
              <h1>Sides</h1>
            </div>
            <Divider />
            <div>
              <p>
                Our sides are optional and included in the base price.
              </p>
            </div>
          </div>
        </ScrollableAnchor>
        <FullMenuItem
          foodName="Salad"
          foodId="Salad"
          description="Our salad is made on the spot and consists of: 
            lettuce, shredded carrots, and shreded red cabbage. Served with ginger dressing."
          background="full-menu__salad"
          foodIcon={salad}
        />
        <FullMenuItem
          foodName="Hibachi Soup"
          foodId="Soup"
          description="Clear broth with sliced mushrooms, fried onions, and green onions."
          background="full-menu__salad"
          foodIcon={soup}
          noImg={true}
        />
      </div>

      <div className="full-menu__specials">
        <ScrollableAnchor id="SpecialsMenu">
          <div className="full-menu__standard-header">
            <div className="full-menu__submenu-header">
              <h1>Specials Menu</h1>
            </div>
            <Divider />
            <div>
              <p>
                Choose additional specials for your Hibachi party. Each special
                is charged per person.
                <Link to="/form"> Contact us to get a quote.</Link>
              </p>
            </div>
          </div>
        </ScrollableAnchor>
        <FullMenuItem
          foodName="Tuna"
          foodId="Tuna"
          description="Classic Tuna seared to your desired temperature. Seasoned with salt,
            lemon, pepper and soy sauce."
          background="full-menu__tuna"
          foodIcon={tuna}
        />
        <FullMenuItem
          foodName="Lobster Tail"
          foodId="LobsterTail"
          description="Decadent Maine Lobster tail seared to your desired temperature. 
            Seasoned with salt, lemon, pepper and garlic butter."
          background="full-menu__lobster-tail"
          foodIcon={lobster}
        />
        <FullMenuItem
          foodName="Scallops"
          foodId="Scallops"
          description="Sea Scallops seared to your desired temperature. Seasoned with salt, 
            lemon, pepper, and garlic butter."
          background="full-menu__scallops"
          foodIcon={scallops}
        />
        <FullMenuItem
          foodName="Mahi Mahi"
          foodId="MahiMahi"
          description="Seared Mahi Mahi. Seasoned with salt, pepper, lemon, garlic butter
            and soy sauce."
          background="full-menu__mahi-mahi"
          foodIcon={mahi}
        />
        <FullMenuItem
          foodName="Filet Mignon"
          foodId="FiletMignon"
          description="Tender filet mignon, cooked to your desired temperature. Seasoned 
            with salt, pepper, and garlic butter."
          background="full-menu__filet-mignon"
          foodIcon={filetMignon}
        />
        <FullMenuItem
          foodName="Salmon"
          foodId="Salmon"
          description="Salmon seared to your desired temperature. Seasoned with salt,
            lemon, pepper, and soy sauce."
          background="full-menu__salmon"
          foodIcon={salmon}
        />
      </div>

      <Cta />
    </div>
  )
}

export default FullMenu



// WEBPACK FOOTER //
// ./src/FullMenu/FullMenu.js